import type {
  FilterOption,
  IncludeExcludeFilterCategory,
} from "./reducers/includeExcludeFilterReducer";

function findInOptions(
  options: readonly FilterOption[],
  categoryId: string,
  optionId: string,
): FilterOption | undefined {
  for (const option of options) {
    if (option.categoryId === categoryId && option.item === optionId) {
      return option;
    }

    const nestedOption = option.subItems
      ? findInOptions(option.subItems, categoryId, optionId)
      : undefined;
    if (nestedOption) {
      return nestedOption;
    }
  }

  return undefined;
}

export function findFilterOption(
  categories: readonly IncludeExcludeFilterCategory[] | undefined,
  categoryId: string,
  optionId: string,
): FilterOption | undefined {
  for (const category of categories ?? []) {
    const option = findInOptions(category.options, categoryId, optionId);
    if (option) {
      return option;
    }
  }

  return undefined;
}
